import { Package } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface ProductColumnTopProps {
  imageSrc: string | null;
  alt: string;
  size: "hero" | "competitor";
  limitedData: boolean;
}

export function ProductColumnTop({
  imageSrc,
  alt,
  size,
  limitedData,
}: ProductColumnTopProps) {
  const isHero = size === "hero";

  return (
    <div className="flex flex-col items-center">
      <div
        className={cn(
          "bg-white rounded flex items-center justify-center",
          isHero ? "w-14 h-14" : "w-12 h-12",
        )}
      >
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={alt}
            className={cn("object-contain", isHero ? "w-12 h-12" : "w-10 h-10")}
          />
        ) : (
          <span
            data-testid="product-image-placeholder"
            className={cn(
              "flex items-center justify-center rounded-md border border-border bg-card text-muted-foreground",
              isHero ? "w-12 h-12" : "w-10 h-10",
            )}
          >
            <Package className="h-4 w-4" />
          </span>
        )}
      </div>
      {limitedData && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge variant="warning" tabIndex={0} className="cursor-default whitespace-nowrap">
              Limited data
            </Badge>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-[280px]">
            Sales and BSR estimates aren't available for this product.
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
